export type DeployTarget = "staging" | "production";

export interface GameplaySessionContext {
  sessionId: string;
  locale: string;
  debugMode: boolean;
  deployTarget: DeployTarget;
}

let currentContext: GameplaySessionContext | null = null;

export function createGameplaySessionId(): string {
  return crypto.randomUUID();
}

export function setGameplaySessionContext(
  context: Omit<GameplaySessionContext, "deployTarget"> & {
    deployTarget?: DeployTarget;
  },
): void {
  currentContext = {
    sessionId: context.sessionId,
    locale: context.locale,
    debugMode: context.debugMode,
    deployTarget: context.deployTarget ?? "production",
  };
}

export function updateGameplaySessionContext(
  patch: Partial<Pick<GameplaySessionContext, "locale" | "debugMode">>,
): void {
  if (!currentContext) {
    return;
  }

  currentContext = {
    ...currentContext,
    ...patch,
  };
}

export function getGameplaySessionContext(): GameplaySessionContext | null {
  return currentContext;
}

export function clearGameplaySessionContext(): void {
  currentContext = null;
}
